var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('page-header'),_c('div',{staticClass:"pb-3"},[_c('lease-edit',{attrs:{"id":_vm.$route.params.leaseId},on:{"submit":_vm.onSubmit}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }